import { render, staticRenderFns } from "./QuickUser.vue?vue&type=template&id=924cbc56&scoped=true&"
import script from "./QuickUser.vue?vue&type=script&lang=js&"
export * from "./QuickUser.vue?vue&type=script&lang=js&"
import style0 from "./QuickUser.vue?vue&type=style&index=0&id=924cbc56&lang=scss&scoped=true&"
import style1 from "@/assets/sass/pages/profile/quick-user.scss?vue&type=style&index=1&id=924cbc56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924cbc56",
  null
  
)

export default component.exports